export enum AppReactQueryKey {
    AppSettings = 'app-settings',
    MapTiles = 'map-tiles',
}
export type ServiceName = 'pam' | 'ntl' | 'sqw' | 'cml' | 'nrc' | 'neo' | 'ntl-ssr' | 'cml-ssr' | 'scr'

export class TimeoutError extends Error {
    constructor(message = 'Request timeout') {
        super(message)
        this.name = 'TimeoutError'
    }
}
